import React from 'react';

export default function ProductRolloutEditor({ locations, prices, assignments, onChange, stages, deferralDays }) {
  const setMonth = (locationIndex, priceId, value) => {
    const rest = assignments.filter(a => a.locationIndex !== locationIndex || a.priceId !== priceId);
    onChange(value === '' ? rest : [...rest, { locationIndex, priceId, startMonth: Number(value) }]);
  };
  return <div style={{ overflowX: 'auto', margin: '12px 0' }}>
    <p style={{ fontSize: 13 }}>Choose the start month for each product at each location. Leave a cell blank for products not included. Products continue billing after their start month. Up to 10 distinct start months are supported.</p>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead><tr><th style={{ textAlign: 'left' }}>Location</th>{prices.map(p => <th key={p.id}>{p.product_name || p.nickname || 'Product'}</th>)}</tr></thead>
      <tbody>{locations.map(loc => <tr key={loc.index}>
        <th style={{ textAlign: 'left', padding: 8 }}>{loc.name || `Location ${loc.index}`}</th>
        {prices.map(p => <td key={p.id} style={{ padding: 8 }}><input
          aria-label={`${loc.name || `Location ${loc.index}`} ${p.product_name || p.nickname || 'Product'} start month`}
          type="number" min="1" step="1" placeholder="Not included"
          value={assignments.find(a => a.locationIndex === loc.index && a.priceId === p.id)?.startMonth ?? ''}
          onChange={e => setMonth(loc.index, p.id, e.target.value)} style={{ width: 125 }}
        /></td>)}
      </tr>)}</tbody>
    </table>
    {!prices.length && <p>Select products below to configure their start months.</p>}
    {stages.map(s => <p key={s.month} style={{ fontSize: 13 }}>
      <strong>Month {s.month}: ${(s.totalCents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/month</strong>
      {' · '}{s.locationIndices.length} locations · {Object.entries(s.quantities).map(([id, qty]) => `${prices.find(p => p.id === id)?.product_name || 'Product'} × ${qty}`).join(', ')}
    </p>)}
    {deferralDays > 0 && <p style={{ fontSize: 12 }}>The first {deferralDays} days have no recurring charge. Month 2 starts when this period ends; later months follow monthly. Totals above exclude phone leases and one-time fees.</p>}
    {!deferralDays && <p style={{ fontSize: 12 }}>Totals above exclude phone leases and one-time fees.</p>}
  </div>;
}
